import React from 'react';
import { NavLink } from 'react-router-dom';

import classes from './SideMenu.module.scss';

const SideMenu = props => {
    return <div className={classes.SideMenu}>
        <div className={classes.SideHeader}>
            <div>CMK2020 Kielce</div>
            <div onClick={props.clicked} className={classes.Close}>&#10005;</div>
        </div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/" exact activeClassName={classes.ActiveLink}>Home</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/about" exact activeClassName={classes.ActiveLink}>About</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/participants" exact activeClassName={classes.ActiveLink}>Participants</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/proceedings" exact activeClassName={classes.ActiveLink}>Proceedings</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/fees-deadlines" exact activeClassName={classes.ActiveLink}>Fees &amp; Deadlines</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/schedule" exact activeClassName={classes.ActiveLink}>Schedule</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/exhibition" exact activeClassName={classes.ActiveLink}>50 Years</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/register" exact activeClassName={classes.ActiveLink}>Register</NavLink></div>
        <div className={classes.SideMenuItem} onClick={props.clicked}>
            <NavLink to="/contact" exact activeClassName={classes.ActiveLink}>Contact us</NavLink></div>
    </div>
}

export default SideMenu;